import { render, staticRenderFns } from "./HomeController.vue?vue&type=template&id=15b97e72&"
import script from "./HomeController.vue?vue&type=script&lang=js&"
export * from "./HomeController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports